import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { offers, Offer } from '../data/product';
import { BUILDER_ID } from '../data/builder';
import { useElementInView } from '../hooks/useElementInView';
import { scrollToPackCta } from '../utils/offerBus';
interface StickyBuyBarProps {
  selectedOffer: Offer['id'];
}
export function StickyBuyBar({
  selectedOffer
}: StickyBuyBarProps) {
  const offer = offers.find(item => item.id === selectedOffer) ?? offers[1];
  const offersInView = useElementInView('offer');
  // The builder has its own live summary bar; never stack two bars.
  const builderInView = useElementInView(BUILDER_ID, '-30% 0px -30% 0px');
  if (builderInView) return null;
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-grit-500/40 bg-ink-950/97 px-4 py-3 backdrop-blur lg:hidden" data-id="element-1352" data-mp="3qez7jn3q7wvl">
      {offersInView ? <div className="flex items-center justify-between gap-3" data-id="element-1353" data-mp="212ezg4wy5fyd">
          <div className="min-w-0" data-id="element-1354" data-mp="1w2j38ruhqstd">
            <p className="truncate font-display text-xl font-extrabold uppercase leading-none text-offwhite" data-id="element-1355" data-mp="1w3kfv0r5nnd7">
              {offer.name}
            </p>
            <p className="mt-1 truncate text-[11px] font-bold uppercase tracking-wide text-grit-500" data-id="element-1356" data-mp="2eevq9bo7ihvl">
              {offer.price}
              <span className="text-steel-400" data-id="element-1357" data-mp="2ie4gw7ny9zmx"> · {offer.kicker} · Free U.S. shipping</span>
            </p>
          </div>
          <a href="#offer" onClick={event => {
        event.preventDefault();
        scrollToPackCta(offer.id);
      }} className="inline-flex shrink-0 items-center gap-1.5 bg-grit-500 px-4 py-3.5 font-display text-base font-extrabold uppercase leading-none text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:gap-2 sm:px-5 sm:text-lg" data-id="element-1358" data-mp="2s57l3ic6euqf">
            Get the deal
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1359" data-mp="1bqza8l0rq9um" />
          </a>
        </div> : <div className="flex items-center justify-between gap-3" data-id="element-1360" data-mp="2f1mv4vhmk2k5">
          <div className="min-w-0" data-id="element-1361" data-mp="2f24x88qyxazz">
            <p className="truncate font-display text-xl font-extrabold uppercase leading-none text-offwhite" data-id="element-1362" data-mp="2a31tqsqmzcu4">
              Build your X1
            </p>
            <p className="mt-1 truncate text-[11px] font-bold uppercase tracking-wide text-grit-500" data-id="element-1363" data-mp="2o3w3pftc1luw">
              From $29.95 <span className="text-steel-400" data-id="element-1364" data-mp="2k32dgfsf3uyu">· Free U.S. shipping</span>
            </p>
          </div>
          <a href={`#${BUILDER_ID}`} className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap bg-grit-500 px-4 py-3.5 font-display text-base font-extrabold uppercase leading-none text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:gap-2 sm:px-5 sm:text-lg" data-id="element-1365" data-mp="2xye9qrm81thv">
            From $29.95
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1366" data-mp="3govxsiw400ww" />
          </a>
        </div>}
    </div>;
}